<template>
  <div id="integrationsModule">
    <div class="!px-3 !py-3 !mb-3 border-b border-black/10 sticky top-0 bg-white z-[1]">
      <div class="d-flex align-center !gap-3">
        <el-button
          @click="goBack"
          size="mini"
          class="bg-transparent !border border-black/20 hover:!border-brand-300 active:!border-brand-500 !py-[6px] !px-2 !rounded-sm hover:!bg-gray-100"
        >
          <span>
            <img src="@/assets/img/icons/new/left-back-icon.svg" alt="" class="!size-3" />
          </span>
        </el-button>
        <h3
          class="!text-sm 2xl:!text-base !font-normal !text-black-950 !m-0 !max-w-64 2xl:!max-w-[500px] truncate"
        >
          Configurations
        </h3>
      </div>
    </div>
    <div class="!px-3">
      <div class="hidden-lg-and-up">
        <el-menu
          default-active="2"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          mode="horizontal"
        >
          <el-menu-item
            :index="`/${getActiveWorkspace.company_id}/configuration/paymentSystems`"
            @click="goto"
            :router="true"
          >
            <i class="el-icon-s-finance"></i>
            <span>Payment Gateway</span>
          </el-menu-item>
          <el-submenu :index="`/${getActiveWorkspace.company_id}/configuration`">
            <template slot="title">
              <i class="el-icon-coin"></i>
              <span>Storage</span>
            </template>
            <el-menu-item-group>
              <el-menu-item
                :index="`/${getActiveWorkspace.company_id}/configuration/s3`"
                @click="goto"
                :router="true"
                disabled
              >
                <i class="el-icon-set-up"></i>
                <span>AWS S3</span>
              </el-menu-item>
              <el-menu-item
                :index="`/${getActiveWorkspace.company_id}/configuration/share_point`"
                @click="goto"
                :router="true"
              >
                <i class="el-icon-set-up"></i>
                <span>Share Point</span>
              </el-menu-item>
              <el-menu-item
                :index="`/${getActiveWorkspace.company_id}/configuration/gdc`"
                @click="goto"
                :router="true"
                disabled
              >
                <i class="el-icon-set-up"></i>
                <span>Google Drive</span>
              </el-menu-item>
              <el-menu-item
                :index="`/${getActiveWorkspace.company_id}/configuration/one_drive`"
                @click="goto"
                :router="true"
                disabled
              >
                <i class="el-icon-set-up"></i>
                <span>One Drive</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item
            :index="`/${getActiveWorkspace.company_id}/configuration/mail`"
            @click="goto"
            :router="true"
          >
            <i class="el-icon-message"></i>
            <span>Mail Configuration</span>
          </el-menu-item>
        </el-menu>
        <div class="clearfix"></div>
      </div>
      <el-row>
        <el-col
          :lg="4"
          class="hidden-md-and-down h-[calc(100vh-150px)] overflow-y-auto overflow-x-hidden box-border !pr-4"
        >
          <el-menu
            id="integrationsMenu"
            default-active="2"
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @close="handleClose"
          >
            <el-menu-item
              :index="`/${getActiveWorkspace.company_id}/configuration/paymentSystems`"
              @click="goto"
              :router="true"
            >
              <i class="el-icon-s-finance"></i>
              <span>Payment Gateway</span>
            </el-menu-item>
            <el-submenu :index="`${getActiveWorkspace.company_id}/configuration`">
              <template slot="title">
                <i class="el-icon-coin"></i>
                <span>Storage</span>
              </template>
              <el-menu-item-group>
                <el-menu-item
                  :index="`/${getActiveWorkspace.company_id}/configuration/s3`"
                  @click="goto"
                  :router="true"
                  disabled
                >
                  <i class="el-icon-set-up"></i>
                  <span>AWS S3</span>
                </el-menu-item>
                <el-menu-item
                  :index="`/${getActiveWorkspace.company_id}/configuration/share_point`"
                  @click="goto"
                  :router="true"
                >
                  <i class="el-icon-set-up"></i>
                  <span>Share Point</span>
                </el-menu-item>
                <el-menu-item
                  :index="`/${getActiveWorkspace.company_id}/configuration/gdc`"
                  @click="goto"
                  :router="true"
                  disabled
                >
                  <i class="el-icon-set-up"></i>
                  <span>Google Drive</span>
                </el-menu-item>
                <el-menu-item
                  :index="`/${getActiveWorkspace.company_id}/configuration/one_drive`"
                  @click="goto"
                  :router="true"
                  disabled
                >
                  <i class="el-icon-set-up"></i>
                  <span>One Drive</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-menu-item
              :index="`/${getActiveWorkspace.company_id}/configuration/mail`"
              @click="goto"
              :router="true"
            >
              <i class="el-icon-message"></i>
              <span>Mail Configuration</span>
            </el-menu-item>
            <el-menu-item
              :index="`/${getActiveWorkspace.company_id}/configuration/AddNewIntegration`"
              @click="goto"
              :router="true"
            >
              <i class="el-icon-chat-dot-round"></i>
              <span>Whatsapp</span>
            </el-menu-item>
            <el-menu-item
              :index="`/${getActiveWorkspace.company_id}/configuration/apiIntegrations/config`"
              @click="goto"
              :router="true"
            >
              <i class="fa fa-gg"></i>
              <span>API Integrations</span>
            </el-menu-item>
            <el-menu-item
              :index="`/${getActiveWorkspace.company_id}/configuration/Chatbot`"
              @click="goto"
              :router="true"
            >
              <i class="fa fa-comments"></i>
              <span>Chat Bot</span>
            </el-menu-item>
            <el-menu-item
              :index="`/${getActiveWorkspace.company_id}/configuration/Internalchat`"
              @click="goto"
              :router="true"
            >
              <i class="fa fa-comments"></i>
              <span>Internal Chat</span>
            </el-menu-item>
            <el-menu-item
              :index="`/${getActiveWorkspace.company_id}/configuration/vitel-global`"
              @click="goto"
              :router="true"
            >
              <i class="fa fa-comments"></i>
              <span>Vitel Global</span>
            </el-menu-item>
            <el-menu-item
              :index="`/${getActiveWorkspace.company_id}/configuration/kf-mail`"
              @click="goto"
              :router="true"
            >
              <i class="el-icon-message"></i>
              <span>KF Mail</span>
            </el-menu-item>
          </el-menu>
        </el-col>

        <el-col
          :md="24"
          :lg="20"
          class="!border !border-page-border !rounded-xl h-[calc(100vh-150px)] overflow-y-auto overflow-x-hidden box-border"
        >
          <component :is="layout">
            <router-view :layout.sync="layout" />
          </component>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import DocumentsHelper from '@/mixins/CompanyDocumentsHelper';
  export default {
    name: 'ProfileBodySettings',
    data() {
      return {
        layout: 'div',
      };
    },
    mixins: [DocumentsHelper],
    mounted() {
      this.getCompanyInformation();
    },
    computed: {
      ...mapGetters('auth', [
        'getUpdateProfilePicStatus',
        'getAuthenticatedUser',
        'getupdateprofilepicture',
        'getActiveWorkspace',
      ]),
      getClass() {
        return (routeName) => {
          if (routeName == this.$route.name) {
            return 'list-group-item list-group-item-action active';
          } else return 'list-group-item list-group-item-action';
        };
      },
    },
    methods: {
      goBack() {
        this.$router.push({
          path: '/',
        });
      },
      goto(e) {
        // console.log(e);
        if (e.index) {
          this.$router.push({
            path: e.index,
            query: {
              _t: Date.now(),
            },
          });
        }
      },
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .profile-page {
    .profile-card {
      border-radius: 4px;
      border: 1px solid #ebeef5;
      margin: 0 -1px;

      .list-group {
        .list-group-item {
          border-radius: 0;
          padding: 1em;
          border: none;
          color: #9299b8;

          [class^='el-icon'] {
            margin-right: 10px;
          }

          &.active {
            color: var(--brand-500);
            border-left: 2px solid var(--brand-500);
          }
        }
      }
    }
  }

  .clearfix {
    padding-bottom: 2rem;
  }
</style>
